import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.414 13l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L3.414 11H13a1 1 0 0 1 0 2H3.414l-1-1H13 2h.414zm7.172-10L9.293 1.707A1 1 0 0 1 10.707.293l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L10.586 5H1a1 1 0 1 1 0-2h9.586l1 1H1h11-.414z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-transfer"}) } }